import React, {useEffect, useState} from "react";
import { withTranslation } from "react-i18next";
import Select from "react-select";
import { withRouter } from "react-router";
import {getConfig, getSsoRetailerList} from "../../api/config";

const SsoDropdown = ({t, history}) => {
    const [options, setoptions] = useState([]);

    const fetchSsoRetailerList = async () => {
        const data = await getSsoRetailerList();
        setoptions(data);
    };

    useEffect(() => {
        fetchSsoRetailerList();
    }, [t]);

    const redirect = (option) => {
        window.location = option.value;
    }

    const customStyles = {
        option: (provided) => ({
            ...provided,
            backgroundColor: "white",
            color: "black",
        }),
        control: (provided) => ({
            ...provided,
            backgroundColor: "transparent",
            border: "none",
            boxShadow: "none",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white",
            width: "100%",
            textAlign: "center",
        }),
        indicatorSeparator: () => ({
            display: "none"
        }),
    };

    const CustomDownChevron = (props) => (
        <svg
            height="20"
            width="20"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
            style={{
                display: 'inline-block',
                fill: 'white',
                lineHeight: 1,
                stroke: 'white',
                strokeWidth: 0,
            }}
            {...props}
        >
            <polygon  points="4,9 10,17 16,9"/>
        </svg>
    )

    const CustomDropdownIndicator = (props) => {
        const { className, cx, getStyles, innerProps } = props;
        return (
            <div
                {...innerProps}
                css={getStyles('dropdownIndicator', props)}
                className={cx(
                    {
                    indicator: true,
                    'dropdown-indicator': true,
                    },
                    className
                )}
            >
                <CustomDownChevron />
            </div>
        );
    }

    if (0 === options.length) {
        return <></>;
    }

    return (
        <div className="select-wrapper">
            <Select
                isSearchable={false}
                classNamePrefix="sso-switcher"
                className="lang-switcher"
                menuPlacement="bottom"
                styles={customStyles}
                components={{
                    DropdownIndicator: CustomDropdownIndicator
                }}
                value={{
                    value: "",
                    label: <u>{t("sso_retailer_login")}</u>,
                }}
                onChange={redirect}
                options={options}
            />
        </div>
    );
};

export default withRouter(withTranslation()(SsoDropdown));
